// API configurations
export const ServerAPI = {
  APIMethod: {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
  } as const,
};

export const API = {
  BaseUrl: "http://54.226.8.102/api/",
};

export const EndPoint = {
  sendotp: "send-otp",
  verifyotp: "verify-otp",
  getdetails: "get-user-details",
  updatedetails: "update-user-details",
  getstateinfobypin: "get-state-info-by-pin",
  getaddressinfo: "get-address-info",
};

// Fetch-based executeAPI function
export const executeAPI = async (
  method: keyof typeof ServerAPI.APIMethod,
  data: any,
  endpoint: string,
  params?: any
): Promise<any> => {
  try {
    const url = new URL(`${API.BaseUrl}${endpoint}`);
    if (params) {
      Object.keys(params).forEach((key) => url.searchParams.append(key, params[key]));
    }

    const config: RequestInit = {
      method,
      headers: {
        "Content-Type": "application/json",
      },
      body: method !== ServerAPI.APIMethod.GET ? JSON.stringify(data) : undefined,
    };

    const response = await fetch(url.toString(), config);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};

// Interfaces for request payloads
export interface SendOtp {
  first_name: string;
  last_name: string;
  phone: number;
  pet_name: string;
  type: string;
  gender: string;
  breed: string;
  dob: string;
  age: number;
  address: string;
  area: string;
  pincode: number;
  city: string;
  country: string;
  state: string;
}

export interface UpdateDetails {
  first_name: string;
  last_name: string;
  phone: number;
  pet_name: string;
  type: string;
  gender: string;
  breed: string;
  dob: string;
  age: number;
  address: string;
  area: string;
  pincode: number;
  city: string;
  country: string;
  state: string;
}

// API functions
export const SendOtp = async (
  first_name: string,
  last_name: string,
  phone: number,
  pet_name: string,
  type: string,
  gender: string,
  breed: string,
  dob: string,
  age: number,
  address: string,
  area: string,
  pincode: number,
  city: string,
  country: string,
  state: string
) => {
  const data: SendOtp = { first_name, last_name, phone, pet_name, type, gender, breed, dob, age, address, area, pincode, city, country, state };
  return await executeAPI(ServerAPI.APIMethod.POST, data, EndPoint.sendotp);
};

export const UpdateDetails = async (
  first_name: string,
  last_name: string,
  phone: number,
  pet_name: string,
  type: string,
  gender: string,
  breed: string,
  dob: string,
  age: number,
  address: string,
  area: string,
  pincode: number,
  city: string,
  country: string,
  state: string,
  id: string
) => {
  const data: UpdateDetails = { first_name, last_name, phone, pet_name, type, gender, breed, dob, age, address, area, pincode, city, country, state };
  return await executeAPI(ServerAPI.APIMethod.POST, data, `${EndPoint.updatedetails}/${id}`);
};

export interface VerifyOtp {
  otp: number;
  id: string;
}

export const VerifyOtp1 = async (otp: number, id: string) => {
  const data: VerifyOtp = { otp, id };
  return await executeAPI(ServerAPI.APIMethod.POST, data, EndPoint.verifyotp);
};

export const GetDetails = async (token: any) => {
  return await executeAPI(ServerAPI.APIMethod.GET, null, `${EndPoint.getdetails}/${token}`);
};

export const GetStateUsingPincode = async (pincode: any) => {
  return await executeAPI(ServerAPI.APIMethod.GET, null, EndPoint.getstateinfobypin, { pincode });
};

export const GetLocation = async (latitude: any, longitude: any) => {
  return await executeAPI(ServerAPI.APIMethod.GET, null, EndPoint.getaddressinfo, { latitude, longitude });
};
